<template>
    <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
      <v-col cols='12'>
        <v-row class="text-center" justify="start" height='90vh' style="margin: 0 0">
          <v-btn text color="orange" @click='$router.push("battleCards")'>Return to Main Menu</v-btn>
        </v-row>
        <v-row class="text-center" justify="start" height='90vh' style="margin: 0 0">
          <v-tabs
            v-model="tab"
            align-with-title
          >
            <v-tabs-slider color="orange"></v-tabs-slider>
              <v-tab  href="#deck">
                Deck
              </v-tab>
              <v-tab  href="#available">
                Available Cards
              </v-tab>
            </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value='deck'>
            <v-col cols='12'>
              <v-row class="text-center" justify="start" height='90vh' style="margin: 0 0">
                <v-col cols="2" v-for="card in activeBattleCardsDeck">
                  <v-hover v-slot:default="{ hover }">

                    <v-card @click="removeCard(card.id)">
                      <v-img
                        :src="card.src"
                        class="white--text align-end"
                        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                        height="300px"
                      >
                      <v-card-actions class='cost'>
                        <v-spacer></v-spacer>
                          <v-icon color='green'>mdi-cash-minus</v-icon>
                          {{card.cost}}
                      </v-card-actions>
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-fast-in-fast-out darken-2 v-card--reveal subtitle-1 white--text"
                            style="height: 100%;"
                            :class="card.color"
                          >
                            {{card.desc}}
                          </div>
                        </v-expand-transition>
                        <v-card-title v-text="card.title"></v-card-title>
                        <v-card-actions>
                          <v-spacer></v-spacer>
          
                          <div v-if="!!card.modifiers[0]">
                            <v-icon color='orange'>mdi-cards</v-icon>
                            {{card.modifiers[0]}}
                          </div>
          
                          <div v-if="!!card.modifiers[1]">
                            <v-icon color='blue'>mdi-shield</v-icon>
                            {{card.modifiers[1]}}
                          </div>
          
                          <div v-if="!!card.modifiers[2]">
                            <v-icon color='red'>mdi-sword</v-icon>
                            {{card.modifiers[2]}}
                          </div>
          
                          <div v-if="!!card.modifiers[3]">
                            <v-icon color='green'>mdi-cash-plus</v-icon>
                            {{card.modifiers[3]}}
                          </div>
                        </v-card-actions>
                      </v-img>
        
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
          </v-tab-item>
          <v-tab-item value='available'>
            <v-col cols='12'>
              <v-row class="text-center" justify="start" height='90vh' style="margin: 0 0">
                <v-col cols="2" v-for="card in battleCardsUnused">
                  <v-hover v-slot:default="{ hover }">
                    <v-card :color='card.color' @click="addCard(card.id)">
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-icon color='green'>mdi-cash-minus</v-icon>
                        {{card.cost}}
                      </v-card-actions>
                      <v-img
                        :src="card.src"
                        class="white--text align-end"
                        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                        height="300px"
                      >
                      <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-fast-in-fast-out darken-2 v-card--reveal subtitle-1 white--text"
                            style="height: 100%;"
                          >
                            {{card.desc}}
                          </div>
                        </v-expand-transition>
                        <v-card-title v-text="card.title"></v-card-title>
                      </v-img>
        
                      <v-card-actions>
                        <v-spacer></v-spacer>
        
                        <div v-if="!!card.modifiers[0]">
                          <v-icon color='orange'>mdi-cards</v-icon>
                          {{card.modifiers[0]}}
                        </div>
        
                        <div v-if="!!card.modifiers[1]">
                          <v-icon color='blue'>mdi-shield</v-icon>
                          {{card.modifiers[1]}}
                        </div>
        
                        <div v-if="!!card.modifiers[2]">
                          <v-icon color='red'>mdi-sword</v-icon>
                          {{card.modifiers[2]}}
                        </div>
        
                        <div v-if="!!card.modifiers[3]">
                          <v-icon color='green'>mdi-cash-plus</v-icon>
                          {{card.modifiers[3]}}
                        </div>
                      </v-card-actions>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
              <v-snackbar
                v-model="deckFullAlert"
                timeout="2000"
              >
                Deck can only contain 24 cards
                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="blue"
                    text
                    v-bind="attrs"
                    @click="deckFullAlert = false"
                  >
                    Close
                  </v-btn>
                </template>
              </v-snackbar>
            </v-col>
          </v-tab-item>
        </v-tabs-items>
        </v-row>
        </v-col>
    </v-row>
</template>

<script>
  export default {
    name: 'battleCardsDeckBuilder',
    data: () => ({
      playing: false,
      tab: 'deck',
      deckFullAlert: false
    }),
    computed: {
      activeBattleCardsDeck () {
        return this.$store.state.activeBattleCardsDeck.sort(function(a, b) {
          var textA = a.title.toUpperCase();
          var textB = b.title.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
      },
      battleCardsUnused () {
        return this.$store.state.battleCardsUnused.sort(function(a, b) {
          var textA = a.title.toUpperCase();
          var textB = b.title.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
      }
    },
    methods: {
      removeCard(cardId){
        this.$store.dispatch('battleCardsRemoveFromDeck', cardId);
      },
      addCard(cardId){
        if(this.activeBattleCardsDeck.length < 24){
          this.$store.dispatch('battleCardsAddToDeck', cardId);
        } else {
          this.deckFullAlert = true;
        }
      },
    }
  }
</script>

<style scoped>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .7;
    position: absolute;
    width: 100%;
    background-color: black;
    cursor: pointer;
  }

  .cost{
    position: absolute;
    top: 0;
    right: 0;
  }
</style>